<template>
  <div class="pt-10 component-div">
    <b-row class="d-flex group-scoring__container-edit">
      <b-col cols="8" class="pl-14" v-if="isDisplayQuestionInfo && displayMobileView === false">
        <span
          v-translate:_title="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.title
          }"
          class="color-white fs-14 ml-10"
          >{{ componentData.title }}</span
        >
      </b-col>
      <b-col cols="7" v-if="isDisplayQuestionInfo && displayMobileView === true">
        <span
          class="color-white fs-14"
          v-translate:_title="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.title
          }"
          >{{ componentData.title }}</span
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as constant from "../../../constants/config";
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-section-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      displayMobileView: Boolean
    };
  },
  created() {
    if (constant.SCREENWIDTH > 1200) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: { type: Boolean, default: false },
    mode: {
      default: 0
    },
    activityInfo: {
      default: () => {}
    }
  }
};
</script>

<style>
.group-scoring__container-edit {
  padding: 2px;
  border-radius: 3px;
  border: solid 1px #b0bac9;
  background-color: #b0bac9;
}
</style>
